<template>
  <!-- page-wrapper Start-->
  <div class="page-wrapper">
    <div class="container py-5">
      <!-- login page start-->
    </div>
    <!-- login page end-->
  </div>
  <!-- latest jquery-->
</template>

<script>
    import {
        checkASANSession,
    } from "@/repositories/GeneralDataRepository";

    export default {
        name: 'Login',
        data() {
            return {
            }
        },
        mounted() {

            this.asanCheck()

        },
        methods: {

            asanCheck() {
                checkASANSession(this.$route.params['transaction']).then(data => {
                    if (data.code === 200) {

                        localStorage.setItem('asanLogin', "yes");

                        localStorage.setItem('token', data.token);
                        window.location.href = "/";

                    }else if (data.code === 404) {

                      let {name, surname} = data;

                        this.$swal({
                            title: this.$t("login.qeydiyyat"),
                            // name surname
                            text: this.$t("login.asanCallback", {name:name,surname:surname}),
                            type: "warning"
                        }).then(() => {
                            window.location.href = "/";
                        })

                    } else {
                        this.$swal({
                            title: `Error ${data.code} !`,
                            text: data.message,
                            type: "error"
                        }).then(() => {
                            window.location.href = "/";
                        })
                    }
                })
            },


        }
    }
</script>

<style scoped>

    .asan-button {
        background: url('@/assets/images/asan.png') no-repeat center #FFFFff;
        background-size: 100% 100%;
        border: none;
    }

</style>
